import { trainedText } from '../text';
import type { GameEvent } from '../types';
import type { DiffContext } from './context';

/**
 * Own units that came out of training this tick: gone from their city's
 * queue and now on the map (or in its barracks) under the same id. A
 * cancelled one, or one lost with its training building or city, never
 * shows up as a unit, so it isn't reported.
 */
export function trainedEvents(c: DiffContext): GameEvent[] {
  const events: GameEvent[] = [];
  for (const [id, t] of c.prev.training) {
    if (c.next.training.has(id)) continue;
    const u = c.next.units.get(id);
    if (!u || u.owner !== c.playerId) continue;
    const trained = {
      counts: { [c.unitName(u.type)]: 1 },
      city: c.cityLabel?.(t.cityId) ?? 'a city',
    };
    events.push({
      kind: 'trained',
      text: trainedText(trained),
      pos: u.pos,
      cityId: t.cityId,
      trained,
    });
  }
  return events;
}
